import {CommuneForm, CommuneFormProps} from "./CommuneForm";
import {PopupForm} from "@tracabois/components";

export interface CommuneFormPopupProps extends CommuneFormProps {
  open: boolean
}

export const CommuneFormPopup = (props: CommuneFormPopupProps) => {
  const {open, ...communeFormProps} = props
  const title = !communeFormProps.item?.id ? "Création d'une commune" : "Commune"
  return (
    <PopupForm open={open} onClose={communeFormProps.onCancel} title={title}>
      <CommuneForm
        {...communeFormProps}
      />
    </PopupForm>
  )
};
